import React from 'react'

import { TraceSummary } from '../domain/TraceSummary'
import Link from '../helper/link'
import Profile from './profile'

interface Props {
    profiles: { profiles: TraceSummary[] }
    profileRoute: string
    compact: boolean
}
class ProfileTable extends React.Component<Props> {
    public static defaultProps = {
        profileRoute: 'XhprofProfilerBundle.Profile.quick',
        compact: false,
    }

    public render() {
        return (
            <table className="table table-condensed profile-list">
                {this.props.profiles && this.props.profiles.profiles && this.props.profiles.profiles.length ? (
                    this.props.profiles.profiles.map((profile, index) => {
                        return (
                            <Profile
                                key={profile.id}
                                rowType={index % 2 ? 'even' : 'odd'}
                                profile={profile}
                                route={this.props.profileRoute}
                                compact={this.props.compact}
                            />
                        )
                    })
                ) : (
                    <tbody>
                        <tr>
                            <td colSpan={8} className="text-center">
                                <p>No traces found for the current time-span and selected criteria.</p>
                                <p>
                                    <Link route="XhprofProfilerBundle.Profile.list" params={{}}>
                                        Clear filters and see a list of all traces
                                    </Link>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        )
    }
}

export default ProfileTable
